import { BaseTable } from './BaseTable'
import { usePriceGetAgDetailsContext } from './PriceGetAgDetailsContext'

export const MeterCostsTable = () => {
  const { getAgPriceDetails, t, tax } = usePriceGetAgDetailsContext()

  return (
    <BaseTable
      rows={[
        {
          label: t(
            'getag_details_table.groups.meter_costs.fees.maintenance_fee',
            'Messstellenbetrieb'
          ),
          isEmpty:
            !getAgPriceDetails.breakdown.static?.['maintenance_fee']?.amount,
          amountDecimal:
            getAgPriceDetails.breakdown.static?.['maintenance_fee']
              ?.amount_decimal,
          tax
        },
        {
          label: t(
            'getag_details_table.groups.meter_costs.fees.metering_reading_fee',
            'Messdienstleistung'
          ),
          isEmpty:
            !getAgPriceDetails.breakdown.static?.['metering_reading_fee']
              ?.amount,
          amountDecimal:
            getAgPriceDetails.breakdown.static?.['metering_reading_fee']
              ?.amount_decimal,
          tax
        }
      ]}
      title={t('getag_details_table.groups.meter_costs.title', 'Zählerkosten')}
    />
  )
}
